"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpApplicationSwitcher = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = require("styled-components");
var baseTheme_1 = __importDefault(require("@greatmindsorg/atomic-ui-lib-lts/dist/themes/baseTheme"));
var GlobalAppSwitcher_component_1 = require("@greatmindsorg/atomic-ui-lib-lts/dist/components/organisms/GlobalAppSwitcher/GlobalAppSwitcher.component");
var DpApplicationSwitcher_styled_1 = require("./DpApplicationSwitcher.styled");
var use_mount_hook_1 = require("../../../api/hooks/use-mount.hook");
var constants_1 = require("../../../api/constants");
var DpApplicationSwitcher = function (_a) {
    // ------------------------------ Const
    var productIds = _a.productIds;
    // ------------------------------ State
    var _b = (0, react_1.useState)([]), products = _b[0], setProducts = _b[1];
    var loadProductOptions = (0, react_1.useCallback)(function () {
        setProducts(productIds);
    }, [setProducts, productIds]);
    (0, use_mount_hook_1.useMount)(function () {
        loadProductOptions();
    });
    return ((0, jsx_runtime_1.jsx)(styled_components_1.ThemeProvider, { theme: baseTheme_1.default, children: (0, jsx_runtime_1.jsx)(DpApplicationSwitcher_styled_1.StyledAppSelector, { className: "app-switcher", children: (0, jsx_runtime_1.jsx)(GlobalAppSwitcher_component_1.GlobalAppSwitcher, { productsList: products, currentPlatform: constants_1.ProductId.Affirm }) }) }));
};
exports.DpApplicationSwitcher = DpApplicationSwitcher;
exports.default = exports.DpApplicationSwitcher;
